import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';

type Props = {
  visible: boolean;
};

/**
 * Full-dialog processing overlay shown during payment transactions.
 * Blocks interaction and shows a spinner + message.
 */
export function ProcessingOverlay({ visible }: Props) {
  const { t } = useTranslation();
  if (!visible) return null;

  return (
    <div className="absolute inset-0 z-30 flex flex-col items-center justify-center bg-background/90 rounded-lg">
      <Loader2 className="h-10 w-10 animate-spin text-primary mb-4" />
      <p className="text-sm font-medium text-center px-6">
        {t('Your transaction is being processed.')}
      </p>
      <p className="text-sm font-medium text-center px-6">
        {t('Please do not close or refresh this page.')}
      </p>
    </div>
  );
}
